import { useState } from "react";
import ModalBasic from "Components/Modal/Modal";
import { InputField } from "Components/Common/InputField/InputField";
import { ApiError } from "Components/Common/ApiError";
import { errorFormatter } from "Helpers/ErrorMsgHandler";
import { useCreateVisitType } from "CustomHooks/useVisitTypes";

const slugify = (value) =>
  String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const AddVisitTypeModal = ({ open, setOpen, onCreated }) => {
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [slugTouched, setSlugTouched] = useState(false);
  const [description, setDescription] = useState("");
  const [apiError, setApiError] = useState("");
  const createVisitType = useCreateVisitType();

  const create = () => {
    createVisitType.mutate({ name, slug, description }, {
      onSuccess: (res) => onCreated?.(res?.id),
      onError: (err) =>
        setApiError(errorFormatter(err?.response?.data?.errors || err?.message)),
    });
  };

  return (
    <ModalBasic
      open={open}
      heading="Add Visit Type"
      btnText="Create"
      loading={createVisitType.isLoading}
      isDisabled={!name || !slug}
      setOpen={(value) => {
        if (value === "Create") {
          create();
        } else {
          setOpen(false);
        }
      }}
    >
      <div className="space-y-3 text-left">
        {apiError && <ApiError error={apiError} setApiError={setApiError} />}
        <InputField
          id="visit-type-name"
          label="Name"
          isRequired
          value={name}
          onChange={(value) => {
            setName(value);
            if (!slugTouched) {
              setSlug(slugify(value));
            }
          }}
        />
        <InputField
          id="visit-type-slug"
          label="Slug (permanent)"
          isRequired
          value={slug}
          onChange={(value) => {
            setSlugTouched(true);
            setSlug(slugify(value));
          }}
        />
        <p className="text-xs text-gray-500 -mt-2">
          Lowercase code name used across the system — cannot be changed later.
        </p>
        <InputField
          id="visit-type-description"
          label="Description"
          value={description}
          onChange={(value) => setDescription(value)}
        />
      </div>
    </ModalBasic>
  );
};
